import { render } from "./TrainingForm.vue?vue&type=template&id=6a578240&scoped=true"
import script from "./TrainingForm.vue?vue&type=script&lang=js"
export * from "./TrainingForm.vue?vue&type=script&lang=js"

import "./TrainingForm.vue?vue&type=style&index=0&id=6a578240&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a578240"]])

export default __exports__